import UserApi from '@/services/rest/bemob/user';
import api from '@/services/utils/base';
import _ from 'lodash';

import ApiServices from '@/services';

export class WorkspacesApi {
  loading: boolean = false;
  error: boolean = false;

  data: any = [];
  dataNormalized: any = [];

  dataPrivate: any = [];
  dataPrivateNormalized: any = {};

  api: UserApi = new UserApi();


  getWorkspaces() {
    this.loading = true;
    return api.get('user/workspaces')
      .then((response: any) => {
        this.loading = false;
        this.updateData(response.data.payload)

        const dataNormalized:any = {};
        const dataPrivateNormalized:any = {};

        response.data.payload.forEach((workspace:any)=>{
          dataNormalized[workspace.id] = workspace;
          if(workspace.type==='private'){
            dataPrivateNormalized[workspace.id] = workspace;
          }
        });
        this.dataNormalized = dataNormalized;
        this.dataPrivateNormalized = dataPrivateNormalized;

      })
  }

  getWorkspaceItems({workspaceId}:{workspaceId:string}) {
    return api.get(`/user/workspaces/${workspaceId}/items`)
      .then((response: any) => {
        return response.data.payload
      })
  }

  put(data: any) {
    return api.put('user/workspaces/'+data.id,{...data}).then(async response=>{
      const responseData = response.data.payload;
      this.dataNormalized[responseData.id] = responseData;
      if(responseData.type==='private'){
        this.dataPrivateNormalized[responseData.id] = responseData;
      }

      this.updateData()
      await ApiServices.getUserProfile()
    });
  }

  putWithoutUserUpdate(data: any) {
    return api.put('user/workspaces/'+data.id,{...data}).then(async response=>{
      const responseData = response.data.payload;
      this.dataNormalized[responseData.id] = responseData;
      if(responseData.type==='private'){
        this.dataPrivateNormalized[responseData.id] = responseData;
      }

      this.updateData()
    });
  }

  post(data: any) {
    return api.post('user/workspaces',{...data}).then(async response=>{
      const responseData = response.data.payload;
      this.dataNormalized[responseData.id] = responseData;
      if(responseData.type==='private'){
        this.dataPrivateNormalized[responseData.id] = responseData;
      }
      this.updateData();
      await ApiServices.getUserProfile()
      return response.data.payload;
    });
  }

  delete(id: string) {
    return api.delete('/v2/workspaces/'+id).then(()=>{
      this.dataNormalized = _.omit(this.dataNormalized,id);
      this.dataPrivateNormalized = _.omit(this.dataPrivateNormalized,id);
      this.updateData()
      return ApiServices.getUserProfile()
    });
  }

  updateData(data?:any){
    let dataPrivate = null;
    if(data){
      dataPrivate = data.filter((workspace:any)=>workspace.type==='private');
    }

     this.data = _.orderBy(Object.values(data || this.dataNormalized), ['deletable','name'], ['asc','asc']);
     this.dataPrivate = _.orderBy(Object.values(dataPrivate || this.dataPrivateNormalized), ['deletable','name'], ['asc','asc']);
  }

}

export default new WorkspacesApi();
